module.exports = __webpack_public_path__ + "static/media/i_v student4.c15d62ca.svg";